export const isSchemaError = str =>
  (str.indexOf("instance") === 0 &&
    ((str.indexOf("<") > -1 && str.indexOf(">") > -1) ||
      str.indexOf("subschema") > -1 ||
      str.indexOf("property") > -1 ||
      str.indexOf("conform") > -1 ||
      str.indexOf("not of a type") > -1)) ||
  str.indexOf("schema") > -1;
